import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { MaisonsComponent } from 'projects/hp-api/src/lib/maisons/maisons.component';
import { FinaliserComponent } from 'projects/hp-api/src/lib/finaliser/finaliser.component';
import { SimulateurComponent } from 'projects/hp-api/src/lib/simulateur/simulateur.component';


import { AppBaseRoutingModule } from 'projects/hp-api/src/lib/app-entry/app-base-routing.module';
import { SelecteurPorteComponent } from 'projects/hp-api/src/lib/selecteur-porte/selecteur-porte.component';
import { HomeComponent } from 'projects/hp-api/src/lib/home/home.component';
import { FinaliserIframeComponent } from 'projects/hp-api/src/lib/finalser-iframe/finaliser-iframe.component';


const routes: Routes = [
  { path: 'belm', component: HomeComponent },
  { path: 'selecteur-maisons', component: MaisonsComponent },
  { path: 'selecteur-de-portes', component: SelecteurPorteComponent },
  { path: 'simulateur-de-portes', component: SimulateurComponent },
  { path: 'simulateur-finalisation', component: FinaliserIframeComponent },
  { path: '', redirectTo: 'belm', pathMatch: 'full' },
  {path: '**', redirectTo: 'belm'}

];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingBelmModule extends AppBaseRoutingModule {

}
